<template>
	<div class="common-shell">
		<gc-header :header-data="headerData" />
		<div class="common-shell-content" v-loading="loading">
			<div class="left-filter">
				<el-form ref="reportForm" :model="params" :rules="filterRules">
					<div class="filter-modules">
						<div class="title">统计条件</div>
						<div class="item">
							<el-form-item :prop="typeInput.key" :label="typeInput.keyWord">
								<el-radio-group v-model="params.reportType">
									<el-radio-button
										v-for="item in typeInput.searchOption"
										:key="item.value"
										:label="item.value"
									>
										{{ item.label }}
									</el-radio-button>
								</el-radio-group>
							</el-form-item>
						</div>
						<div class="item">
							<el-form-item :prop="yearInput.key" :label="yearInput.keyWord">
								<el-radio-group v-model="params.year">
									<el-radio-button
										v-for="item in yearInput.searchOption"
										:key="item.value"
										:label="item.value"
									>
										{{ item.label }}
									</el-radio-button>
								</el-radio-group>
							</el-form-item>
						</div>
						<div v-if="params.reportType && params.reportType !== 3" class="item">
							<el-form-item :prop="dateSubInput.key" :label="dateSubInput.keyWord">
								<el-select v-model="params.dateSub" :placeholder="`请选择活动${dateSubInput.keyWord}`">
									<el-option
										v-for="item in dateSubInput.searchOption"
										:key="item.value"
										:label="item.label"
										:value="item.value"
									></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
				</el-form>
				<div class="button-zone">
					<el-button v-click-blur size="small" type="primary" @click="query">查询</el-button>
					<el-button
						v-click-blur
						size="small"
						:type="exportable ? 'primary' : 'default'"
						plain
						@click="downloadReport"
						:disabled="!exportable"
					>
						导出
					</el-button>
				</div>
			</div>
			<div class="right-table">
				<!-- A4 尺寸容器，预览报告效果，并基于此生成 pdf  -->
				<div v-if="reportData" ref="reportContainer" class="report-container">
					<Report ref="reportComponent" :data="reportData" />
				</div>
				<gc-empty v-else></gc-empty>
			</div>
		</div>
	</div>
</template>

<script>
import Report from './report.vue'
import { exportToPDFImproved } from './pdf/exportToPDFImproved'
import { operationsReportQuery } from '@/apis/statisticAnalysis.api'

export default {
	name: '',
	components: {
		Report,
	},
	props: {
		type: String,
	},
	data() {
		return {
			params: {
				reportType: '',
				year: '',
				dateSub: '',
			},
			typeInput: {
				key: 'reportType',
				type: 'select',
				keyWord: '报告类型',
				searchOption: [
					{
						label: '月度',
						value: 1,
					},
					{
						label: '季度',
						value: 2,
					},
					{
						label: '年度',
						value: 3,
					},
				],
			},
			headerData: {
				pic: 'statistical-analysis',
				title: '运行监测报告',
				desc: '按月度、季度、年度生成物联网平台监测报告',
			},
			loading: false,
			exportable: false,
			reportData: null,
		}
	},
	computed: {
		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},
		yearInput() {
			const currentYear = new Date().getFullYear()
			return {
				key: 'year',
				type: 'select',
				keyWord: '报告年份',
				searchOption: [
					{
						label: currentYear,
						value: currentYear,
					},
					{
						label: currentYear - 1,
						value: currentYear - 1,
					},
				],
			}
		},
		dateSubInput() {
			const type = this.params.reportType
			const options = []
			const year = this.params.year
			const currentYear = new Date().getFullYear()
			const currentMonth = new Date().getMonth() + 1
			if (type === 1) {
				const monthCount = currentYear === year ? currentMonth : 12
				for (let i = 1; i <= monthCount; i++) {
					options.push({
						label: `${year}年${i < 10 ? '0' + i : i}月`,
						value: i,
					})
				}
			} else if (type === 2) {
				const quarterCount = currentYear === year ? Math.ceil(currentMonth / 3) : 4
				for (let i = 1; i <= quarterCount; i++) {
					options.push({
						label: `${year}年第${i}季度`,
						value: i,
					})
				}
			}
			return {
				key: 'dateSub',
				type: 'select',
				keyWord: `报告${type === 1 ? '月份' : type === 2 ? '季度' : ''}`,
				clearable: false,
				searchOption: options,
			}
		},
		filterRules() {
			const type = this.params.reportType
			const rules = {
				reportType: [{ required: true, message: '请选择报告类型', trigger: ['blur'] }],
				year: [{ required: true, message: '请选择报告年份', trigger: ['blur'] }],
				dateSub: [
					{
						required: true,
						message: `请选择报告${type === 1 ? '月份' : type === 2 ? '季度' : ''}`,
						trigger: ['blur'],
					},
				],
			}
			if (type === 3) {
				delete rules.dateSub
			}
			return rules
		},
	},
	watch: {
		filterRules: {
			handler() {
				setTimeout(() => {
					this.$refs.reportForm.clearValidate()
				}, 0)
			},
			deep: true,
		},
		'params.reportType': {
			handler() {
				this.params.dateSub = ''
			},
		},
	},
	methods: {
		getSearchParams() {
			let obj = {
				tenantId: this.tenantId,
				reportType: this.params.reportType,
			}
			// 通过 reportType、year、dateSub 构造 startTime endTime
			const type = this.params.reportType
			const year = this.params.year
			const dateSub = this.params.dateSub
			if (type === 1) {
				obj.startTime = this.dayjs(`${year}-${dateSub < 10 ? '0' + dateSub : dateSub}-01`).format(
					'YYYY-MM-DD HH:mm:ss',
				)
				obj.endTime = this.dayjs(`${year}-${dateSub < 10 ? '0' + dateSub : dateSub}-01`)
					.endOf('month')
					.format('YYYY-MM-DD HH:mm:ss')
			} else if (type === 2) {
				obj.startTime = this.dayjs(`${year}-${(dateSub - 1) * 3 + 1}-01`).format('YYYY-MM-DD HH:mm:ss')
				obj.endTime = this.dayjs(`${year}-${(dateSub - 1) * 3 + 1}-01`)
					.endOf('quarter')
					.format('YYYY-MM-DD HH:mm:ss')
			} else if (type === 3) {
				obj.startTime = this.dayjs(`${year}-01-01`).format('YYYY-MM-DD HH:mm:ss')
				obj.endTime = this.dayjs(`${year}-01-01`).endOf('year').format('YYYY-MM-DD HH:mm:ss')
			}
			return obj
		},
		query() {
			this.$refs.reportForm.validate(async valid => {
				if (valid) {
					this.loading = true
					const obj = this.getSearchParams()
					const res = await operationsReportQuery(obj).catch(() => {
						this.$message.error('查询失败，请重试')
						return false
					})
					this.loading = false
					if (!res) {
						this.reportData = obj
						this.exportable = true
						return
					}
					this.reportData = Object.assign(obj, res, this.params)
					this.exportable = true
				}
			})
		},
		// 导出报表
		async downloadReport() {
			if (!this.exportable) {
				return
			}

			if (this.$refs.reportContainer) {
				this.$refs.reportContainer.scrollTop = 0
			}

			this.$toast('正在生成 PDF，请稍后...')

			const typeMap = {
				1: '月报',
				2: '季报',
				3: '年报',
			}

			// 获取 Report 组件 DOM 元素
			const reportElement = this.$refs.reportComponent?.$el || document.querySelector('.operations-report')

			if (!reportElement) {
				this.$toast.clear()
				this.$message.error('未找到报告内容')
				return
			}

			const reportType = typeMap[this.params.reportType]
			const number = `${this.params.year}${this.getDateSubText()}`
			const date = this.dayjs(Date.now()).format('YYYY-MM-DD')
			const fileName = `物联网平台监测${reportType}-${number}-${date}`

			try {
				await exportToPDFImproved(reportElement, {
					filename: fileName,
					title: fileName,
					includeCharts: true,
				})
				this.$message.success(`${fileName}.pdf 导出成功`)
			} catch (error) {
				this.$message.error('导出失败，请重试')
			} finally {
				this.$toast.clear()
			}
		},

		// 获取日期后缀文本
		getDateSubText() {
			const type = this.params.reportType
			const dateSub = this.params.dateSub

			if (type === 1) {
				return `年${dateSub}月`
			} else if (type === 2) {
				return `年第${dateSub}季度`
			} else if (type === 3) {
				return '年度'
			}
			return ''
		},
	},
}
</script>
<style lang="scss" scoped>
.common-shell {
	@include base-button(150px);
	height: 100%;
	display: flex;
	flex-direction: column;
	align-content: flex-start;
	&-content {
		flex: 1;
		display: flex;
		height: 0;
		.left-filter {
			width: 366px;
			height: 100%;
			padding: 18px 20px 12px;
			border-right: 1px solid #f1f1f1;
			box-sizing: border-box;
			overflow: auto;
			.filter-modules {
				padding-bottom: 10px;
				.title {
					font-size: 17px;
					font-weight: 600;
					color: #333333;
				}
				.item {
					margin: 20px 0;
				}
			}
			.button-zone {
				display: flex;
				align-items: center;
				justify-content: space-between;
			}
		}
		.right-table {
			flex: 1;
			width: 0;
			padding: 18px 20px 0;
			.table {
				height: 100%;
				display: flex;
				flex-direction: column;
				.water-statistic {
					margin-bottom: 12px;
					display: flex;
					.t {
						margin-right: 20px;
					}
					.statistic-item {
						margin-right: 24px;
						display: flex;
						align-items: center;
						p {
							color: #999;
							margin-right: 6px;
						}
					}
				}
				.table-content {
					flex: 1;
					height: 0;
				}
			}
		}
	}
}
::v-deep {
	.el-form-item--small .el-form-item__content {
		line-height: 0;
		flex: 1;
	}
	.gc-custom-search {
		width: initial !important;
	}

	.el-form-item {
		display: flex;
	}

	.el-button[disabled] {
		pointer-events: none;
		opacity: 0.5;
	}
}

.report-container {
	overflow: auto;
	height: 100%;
}
</style>
